import React, { useMemo } from 'react';

import EntityDropDownFilterContainerComponent from 'components/entityViewer/entitiesDropDownFilter/EntityDropDownFilterContainer';
import {
    useFacilityOptions,
    useStatusOptions,
    useVendorOptions,
} from 'components/procurement/components/purchaseOrdersV2/queries/PurchaseOrderQueries';

import { FILTER_QUERY_KEYS, PackagingPOFilterConfigArray } from './PackagingPOFilterConfig';

export function PackagingPOFilters({ initialValues = {}, onChange }) {
    const { data: statusOptions = [], isLoading: isLoadingStatuses } = useStatusOptions();
    const { data: vendorOptions = [], isLoading: isLoadingVendors } = useVendorOptions();
    const { data: facilityOptions = [], isLoading: isLoadingFacilities } = useFacilityOptions();

    const effectiveFilterConfigs = useMemo(
        () =>
            PackagingPOFilterConfigArray.map((cfg) => {
                const queryId = cfg.remoteOptions?.queryId;

                if (queryId === FILTER_QUERY_KEYS.STATUSES) {
                    return {
                        ...cfg,
                        options: statusOptions,
                        menuProps: {
                            ...cfg.menuProps,
                            isLoading: isLoadingStatuses,
                        },
                    };
                }

                if (queryId === FILTER_QUERY_KEYS.VENDORS) {
                    return {
                        ...cfg,
                        options: vendorOptions,
                        menuProps: {
                            ...cfg.menuProps,
                            isLoading: isLoadingVendors,
                        },
                    };
                }

                if (queryId === FILTER_QUERY_KEYS.FACILITIES) {
                    return {
                        ...cfg,
                        options: facilityOptions,
                        menuProps: {
                            ...cfg.menuProps,
                            isLoading: isLoadingFacilities,
                        },
                    };
                }

                return cfg;
            }),
        [facilityOptions, isLoadingFacilities, isLoadingStatuses, isLoadingVendors, statusOptions, vendorOptions],
    );

    const handleFilterChange = (filterValues) => {
        if (onChange) {
            onChange(filterValues);
        }
    };

    return (
        <EntityDropDownFilterContainerComponent
            title="Packaging PO Filters"
            filterConfigs={effectiveFilterConfigs}
            initialValues={initialValues}
            onChange={handleFilterChange}
            autoApply
        />
    );
}
